import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Build } from '@mui/icons-material';

/**
 * Componente che mostra una pagina di manutenzione per "Mio Orario"
 * Utilizzato per utenti con ruolo Coordinatore
 */
const MioOrarioManutenzione: React.FC = () => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '80vh',
      backgroundColor: '#f5f5f5',
      padding: 4
    }}>
      <Paper sx={{ 
        padding: 6, 
        textAlign: 'center', 
        maxWidth: 600,
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: '#fff3cd',
        border: '2px solid #ffc107'
      }}>
        <Build sx={{ fontSize: 80, color: '#856404', mb: 2 }} />
        <Typography variant="h4" gutterBottom sx={{ color: '#856404', fontWeight: 'bold', mb: 3 }}>
          🔧 Pagina in Manutenzione
        </Typography>
        <Typography variant="body1" sx={{ color: '#856404', mb: 2, fontSize: '1.1rem' }}>
          La sezione <strong>"Mio Orario"</strong> è momentaneamente in manutenzione per gli utenti con ruolo Coordinatore.
        </Typography>
        <Typography variant="body2" sx={{ color: '#856404', fontStyle: 'italic' }}>
          Ci scusiamo per il disagio. La funzionalità sarà ripristinata a breve.
        </Typography>
      </Paper>
    </Box>
  );
};

export default MioOrarioManutenzione;
